import { render, staticRenderFns } from "./AgingReportDashboard.vue?vue&type=template&id=5d8f4ce1&scoped=true"
import script from "./AgingReportDashboard.vue?vue&type=script&lang=js"
export * from "./AgingReportDashboard.vue?vue&type=script&lang=js"
import style0 from "./AgingReportDashboard.vue?vue&type=style&index=0&id=5d8f4ce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f4ce1",
  null
  
)

export default component.exports